import React, { useEffect, useRef, useState } from 'react';
import "./SmsVerification.scss";
import { Button, Col, Row } from 'react-bootstrap';
import { InputOtp } from 'primereact/inputotp';
import { MainApi, DashboardApi } from "../../../../services/authentication/api";
import { Configuration } from '../../../../services/authentication/configuration';
import { Toast } from "primereact/toast";
import { t, use } from 'i18next';
import { set } from 'lodash';
import { useSelector } from 'react-redux';
import moment from 'moment';
import JSEncrypt from "jsencrypt";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRegisterInputs } from '../../../../stores/registerSlice';

const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

const SmsVerification = (props) => { // phoneNumber, email
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(MetKey);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toast = useRef(null);
    const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const dashboardApi = new DashboardApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const [token, setTokens] = useState('');
    const [timer, setTimer] = useState(180);
    const [isTokenValid, setIsTokenValid] = useState(true);
    const email = useSelector((state) => state.register.email);
    const name = useSelector((state) => state.register.name);
    const surname = useSelector((state) => state.register.surname);
    const phone = useSelector((state) => state.register.phone).replace(/[^\d]/g, '');
    const password = useSelector((state) => state.register.password);
    const cityCode = useSelector((state) => state.register.city.code);
    const address = useSelector((state) => state.register.address);
    const interestedProducts = useSelector((state) => state.register.interestedProducts);
    const investmentAmount = useSelector((state) => state.register.investmentAmount);




    const [fingerPrint, setFingerPrint] = useState('');

    const customInput = ({ events, props }) => (
        <input
            {...events}
            {...props}
            type="text"
            className={`custom-otp-input ${!isTokenValid ? 'invalid' : ''}`}
        />
    );

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prevTimer => (prevTimer > 0 ? prevTimer - 1 : 0));
        }, 1000);
        return () => clearInterval(countdown);
    }, []);


    useEffect(() => {
        if (fingerPrint) {
            console.log("fingerPrint: ", fingerPrint);
            registerDemoAccount();
        }
    }, [fingerPrint]);


    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    const clickVerify = () => {
        confirmVerification();
    }

    const clickResendSMS = () => {
        console.log('clickResendSMS');

        resendVerificationSMS();
    }

    const handleTokenChange = (e) => {
        setTokens(e.value);
        setIsTokenValid(true); // Reset the validity status on input change
    }

    //#region API Calls


    const resendVerificationSMS = async () => {

        try {
            toast.current.show({ severity: "info", summary: "Bilgi", detail: "SMS gönderiliyor..." });
            dashboardApi.apiDashboardSendDemoSmsGet(email, name, surname, phone).then((response) => {
                console.log("apiDashboardSendDemoSmsGet: ", response);

                if (response.data.Status == "Ok") {
                    toast.current.show({ severity: "success", summary: "Başarılı", detail: "SMS gönderildi. Lütfen telefonunuza gelen kodu giriniz." });
                    setTimeout(() => {
                        setTimer(180);
                    }, 1000);
                }
                else {
                    if (response.data.Error?.includes("0x6DC2CA")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " Lütfen tekrar deneyiniz." });
                    }
                    else if (response.data.Error.includes("0x0c457d")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " 5 ile başlayan 10 haneli Numara girilmeli." });
                    }
                    else {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: "" + response.data.Error });
                    }
                }
            }).catch((error) => {
                console.log("apiDashboardSendDemoSmsGet: ", error);
                toast.current.show({ severity: "error", summary: "Kayıt işlemi başarısız", detail: "Detay: " + error.message });
            });
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulaması yapılırken bir hata oluştu. Lütfen tekrar deneyin.' });
        }
    }



    const confirmVerification = async () => {
        try {
            if (token.length !== 6) {
                setIsTokenValid(false);
                return;
            }
            if (timer === 0) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulama kodunuzun süresi dolmuştur. Lütfen tekrar deneyin.' });
                return;
            }
            const response = await dashboardApi.apiDashboardConfirmDemoSmsGet(token, email).then((res) => {
                console.log(res);


                if (res.data.Status == "Ok") {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'SMS doğrulaması başarıyla gerçekleştirildi.' });
                    setIsTokenValid(true);
                    setFingerPrint(res.data.Data);

                }
                else if (res.data.Status && res.data.Status == "Error") {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'SMS doğrulaması başarıyla gerçekleştirildi.' });
                    setIsTokenValid(true);
                    setFingerPrint(res.data.Data);
                    if (res.data.Error.includes("0x0F4761")) {
                        toast.current.show({ severity: 'error', summary: 'SMS doğrulaması yapılamadı!', detail: ' Geçersiz doğrulama kodu. Yeni kod isteyiniz.' });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'SMS doğrulaması yapılamadı!', detail: ' ' + res.data.Error });
                    }
                }
            })

        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulaması yapılırken bir hata oluştu. Lütfen tekrar deneyin.' });
            setIsTokenValid(false);
        }
    }
    const loginRedirect = () => {
        navigate("/auth/login");
    };
    const registerDemoAccount = async () => {
        try {
            
            let expireDate = moment().add(30, 'days').toISOString(); // Calculate expiration date
            const encryptPassword = encrypt.encrypt(password);
            const encryptEmail = encrypt.encrypt(email);

            const demoAccountRequest = {
                "FingerPrint": fingerPrint,
                "Email": encryptEmail,
                "Password": encryptPassword,
                "Name": name,
                "Surname": surname,
                "PhoneNumber": phone,
                "CityCode": cityCode,
                "ExpireDate": expireDate,
                "Address": address,
                "InterestedProducts": Array.isArray(interestedProducts)
                    ? interestedProducts.map(item => item.code)
                    : [],
                "InvestmentAmount": investmentAmount.code,

            }
            
            dashboardApi.apiDashboardRegisterDemoAccountPost(demoAccountRequest).then((res) => {
                console.log("apiDashboardRegisterDemoAccountPost: ", res);

                if (res.data.Status == "Ok") {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Demo hesabınız başarıyla oluşturuldu. ' });

                    dispatch(setRegisterInputs({
                        name: "",
                        surname: "",
                        email: "",
                        phone: "",
                        password: "",
                        passwordRetry: "",
                        address: "",
                        city: { id: "01", name: "İstanbul", code: 34 },
                        country: { id: "90", name: "Türkiye", code: 90, flag: undefined, sCode: "tr" },
                        interestedProducts: [],
                        investmentAmount: {},
                    }));
                    setTimeout(() => {
                        loginRedirect();
                    }, 2000);
                }
                else if (res.data.Status && res.data.Status == "Error") {
       
                    if (res.data.Error.includes("0xFF5733")) {
                        toast.current.show({
                            severity: 'error', summary: 'Demo hesabı oluşturulamadı!', detail: email + ' Bu mail adresi ile daha önce demo hesabı oluşturulmuş. Lütfen farklı bir mail adresi kullanın.'
                        });

                        dispatch(setRegisterInputs({
                            name: "",
                            surname: "",
                            email: "",
                            phone: "",
                            password: "",
                            passwordRetry: "",
                        }));
                        setTimeout(() => {
                            loginRedirect();
                        }, 3000);
                    }
                    else if (res.data.Error.includes("0xFF5735")) {
                        toast.current.show({
                            severity: 'error', summary: 'Demo hesabı oluşturulamadı!', detail: phone + ' Bu telefon numarası ile daha önce demo hesabı oluşturulmuş. Lütfen farklı bir telefon numarası kullanın.'
                        });

                        dispatch(setRegisterInputs({
                            name: "",
                            surname: "",
                            email: "",
                            phone: "",
                            password: "",
                            passwordRetry: "",
                        }));
                        setTimeout(() => {
                            loginRedirect();
                        }, 3000);
                    }
                    else if (res.data.Error.includes("0x2393B2")) {
                        toast.current.show({
                            severity: 'error', summary: 'Demo hesabı oluşturulamadı!', detail: 'Finger print yanlış'
                        });

                        dispatch(setRegisterInputs({
                            name: "",
                            surname: "",
                            email: "",
                            phone: "",
                            password: "",
                            passwordRetry: "",
                        }));
                        setTimeout(() => {
                            loginRedirect();
                        }, 3000);
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Demo hesabı oluşturulamadı!', detail: ' ' + res.data.Error });
                    }
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Demo hesabınız oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.' });
                }
            }).catch((error) => {
                console.log("apiDashboardRegisterDemoAccountPost: ", error);
                toast.current.show({ severity: "error", summary: "Kayıt işlemi başarısız", detail: "Detay: " + error });
            });
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Demo hesabınız oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.' });
        }
    }




    //#endregion API Calls

    return (
        <div className='sms-verification-component'>
            <Toast ref={toast} position="bottom-right" />

            <Col>
                <Row>
                    <label className='page-title'>SMS Doğrulama</label>
                </Row>
                <Row>
                    <label className='page-description'>Lütfen cep telefonunuza SMS olarak gelen 6 haneli
                        onay kodunu giriniz.</label>
                </Row>
            </Col>

            <Col>
                <InputOtp value={token} length={6} onChange={handleTokenChange} inputTemplate={customInput} />
            </Col>

            <Col>
                <Row className='timer-container justify-content-center'>
                    <span className={`timer ${timer === 0 ? 'expired' : ''}`}>{formatTime(timer)}</span>
                </Row>
            </Col>

            <Col className='m-t-10'>
                <Row style={{ display: "inline" }} className="m-0 ">
                    <Button
                        slot="end"
                        variant="dark"
                        className="button-verify m-t-30 m-b-15"
                        onClick={clickVerify}
                    >
                        DOĞRULA
                    </Button>
                    <Button
                        slot="end"
                        variant="dark"
                        className="button-resend m-t-5 m-b-15"
                        onClick={clickResendSMS}
                    // disabled={timer !== 0}
                    >
                        YENİDEN GÖNDER
                    </Button>

                </Row>
            </Col>
        </div>
    );
}

export default SmsVerification;
